import { CtPlatformType } from 'models/general';
import { StoreContext } from 'models/import';
import { useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Btn, { BtnModifier } from './btn';
import PlatformCard, { PlatformCardModifier, PlatformCardProps } from './platformCard';

export interface PlatformCardItem {
  icon?: React.ReactElement;
  logo_uri?: string;
  name: string;
  platform_type: CtPlatformType;
  display_name: string;
  custom_api_uri: string | null;
  custom_csv_uri: string | null;
  beta: boolean;
  warningCount?: number;
}

export interface PlatformCardsProps {
  items: PlatformCardItem[];
}

function PlatformCards(props: PlatformCardsProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isIntegrationsPage } = useContext(StoreContext);
  const groupRefs = useRef<HTMLDivElement[]>([]);

  const setCardsActivity = (index: number) => {
    groupRefs.current.forEach((cardEl: HTMLDivElement, i) => {
      if (i === index) {
        cardEl.classList.add('_active');
      } else if (i !== index) {
        cardEl.classList.remove('_active');
      }
    });
  };

  const onNavigate = (url: string | null) => {
    if (url && url.length) {
      window.location.href = url;
    }
  };

  const handleCardClick = (
    type: CtPlatformType,
    target: string,
    index: number,
    api_uri: string | null,
    csv_uri: string | null,
  ) => {
    if (isIntegrationsPage) {
      const hasApiUri = api_uri !== undefined && api_uri !== null;
      const hasCsvUri = csv_uri !== undefined && csv_uri !== null;

      if (hasApiUri || hasCsvUri) onNavigate(api_uri || csv_uri);
    } else {
      navigate(`/platform/${type}/${target}`);
    }
  };

  const addGroupRef = (ref: HTMLDivElement) => {
    if (ref !== null && !groupRefs.current.includes(ref)) {
      groupRefs.current.push(ref);
    }
  };

  return (
    <div className={`ct_platformCards ${isIntegrationsPage ? '_integrations' : ''}`}>
      {props.items.map((item: PlatformCardItem, index) => (
        <div key={index} className="ct_platformCards-item">
          <div
            ref={addGroupRef}
            aria-hidden
            onClick={() => handleCardClick(
              item.platform_type,
              item.name,
              index,
              item.custom_api_uri,
              item.custom_csv_uri,
            )}
          >
            <PlatformCard
              icon={item.icon}
              logo_uri={item.logo_uri}
              name={item.name}
              display_name={item.display_name}
              beta={item.beta}
              warningCount={item.warningCount}
              modifiers={[PlatformCardModifier.INTEGRATION]}
            />
            {!!isIntegrationsPage && (item.custom_api_uri && item.custom_csv_uri) && (
            <div className="ct_platformCard-actions">
              {!!item.custom_api_uri && (
              <Btn onClick={() => onNavigate(item.custom_api_uri)} type="primary" text={t('API', { ns: 'imports' })} modifier={[BtnModifier.SMALL]} />
              )}
              {!!item.custom_csv_uri && (
              <Btn onClick={() => onNavigate(item.custom_csv_uri)} type="primary" text={t('CSV', { ns: 'imports' })} modifier={[BtnModifier.SMALL]} />
              )}
            </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default PlatformCards;
